/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer } from './WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer';
import {
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerFromJSONTyped,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerToJSON,
} from './WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer';

/**
 * The answers of one person in a household.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto {
    /**
     * The member id.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto
     */
    memberId?: number;
    /**
     * The answer for each time.
     * @type {Array<WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto
     */
    timeAnswers?: Array<WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto {
    return WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'timeAnswers': !exists(json, 'timeAnswers') ? undefined : (json['timeAnswers'] === null ? null : (json['timeAnswers'] as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'timeAnswers': value.timeAnswers === undefined ? undefined : (value.timeAnswers === null ? null : (value.timeAnswers as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerToJSON)),
    };
}

